module.exports = __webpack_public_path__ + "img/coupon_popup.7c0e6c55.png";